import React from 'react';

import { useGetDashboardEmployeeStatsQuery } from 'src/api';

export const useOverviewEmployeeStats = () => {
  const { data, loading } = useGetDashboardEmployeeStatsQuery();

  const employeeCounts = React.useMemo(
    () =>
      data?.getDashboardEmployeeUserStats ?? {
        total: 0,
        percentage: 0,
        breakdown: { Active: 0, Inactive: 0, Pending: 0 },
      },
    [data],
  );

  return {
    employeeCounts,
    employeeStatsLoading: loading,
  };
};
